export default {
  'ip.list_failed': 'Unable to load IP results. Please retry.',
  'ip.invalid_query': 'Check the IP, country code, ASN and risk score filters.',
  'ip.members_failed': 'Unable to load associated members. Please retry.',
  'ip.history_budget': 'Historical budget used; new IPs remain eligible',
  'ip.library': 'IP library',
  'ip.detail': 'IP details',
  'ip.unknown': 'Unknown',
  'ip.detected': 'Detected',
  'ip.not_detected': 'Not detected',
  'ip.pending': 'Pending',
  'ip.running': 'Collecting',
  'ip.complete': 'Collected',
  'ip.retry': 'Awaiting retry',
  'ip.skipped': 'Not queryable',
  'ip.unavailable': 'IP information unavailable',
  'ip.operator_origin': 'Account operator IP',
  'ip.state': 'Status',
  'ip.flag': 'Detection',
  'ip.latest_notice':
    'This is the last lookup for this IP, not evidence of its status at a past login. Location describes the network exit.',
  'ip.permanent_notice':
    'Successful results are reused permanently. Retry applies only to IPs without a successful lookup.',
  'ip.shared_notice':
    'Provider quota is shared with RGB. Usage can be delayed; BOP reserves its budget conservatively.',
  'ip.asn': 'ASN',
  'ip.provider': 'Provider',
  'ip.organisation': 'Organisation',
  'ip.network_type': 'Network type',
  'ip.network_range': 'Network range',
  'ip.hostname': 'Hostname',
  'ip.country': 'Country',
  'ip.country_code': 'Country code',
  'ip.region': 'Region',
  'ip.city': 'City',
  'ip.timezone': 'Time zone',
  'ip.latitude': 'Latitude',
  'ip.longitude': 'Longitude',
  'ip.proxy': 'Proxy',
  'ip.vpn': 'VPN',
  'ip.hosting': 'Hosting',
  'ip.tor': 'TOR',
  'ip.anonymous': 'Anonymous',
  'ip.scraper': 'Scraper',
  'ip.compromised': 'Compromised',
  'ip.risk': 'Risk score',
  'ip.confidence': 'Confidence',
  'ip.operator_name': 'Operator',
  'ip.source': 'Source',
  'ip.api_version': 'API version',
  'ip.checked_ts': 'Checked at',
  'ip.provider_updated_ts': 'Provider updated at',
  'ip.first_seen_ts': 'First observed',
  'ip.last_seen_ts': 'Last observed',
  'ip.next_attempt_ts': 'Next attempt',
  'ip.heartbeat_ts': 'Collector heartbeat',
  'ip.resume_ts': 'Resume at',
  'ip.reason': 'Reason',
  'ip.risk_min': 'Minimum risk',
  'ip.risk_max': 'Maximum risk',
  'ip.actions': 'Actions',
  'ip.members': 'Related members',
  'ip.nickname': 'Nickname',
  'ip.sources': 'Association sources',
  'ip.registration': 'Registration source',
  'ip.last_login': 'Last login source',
  'ip.login_history': 'Successful logins',
  'ip.retry_action': 'Retry lookup',
  'ip.queued': 'Queued',
  'ip.already_queued': 'Already queued',
  'ip.cooldown': 'Please retry later',
  'ip.collector': 'Collector',
  'ip.local_used': 'BOP reserved today',
  'ip.provider_used': 'Provider usage',
  'ip.disabled': 'Disabled',
  'ip.unconfigured': 'Key not configured',
  'ip.idle': 'Idle',
  'ip.processed': 'Batch completed',
  'ip.paused': 'Paused',
  'ip.error': 'Lookup failed',
  'ip.lease_expired': 'Awaiting recovery',
  'ip.backfill_incomplete': 'Backfill is incomplete. Associations may be missing.',
  'ip.recent_30_days_and_profiles':
    'Profiles and recent logins have been scanned. Only retained login records are included; operator IPs do not prove player access.',
  'ip.error.non_public_ip': 'Non-public or invalid IP',
  'ip.error.auth_error': 'Provider authentication failed',
  'ip.error.rate_limited': 'Provider rate limited',
  'ip.error.daily_limit': 'Daily budget exhausted',
  'ip.error.provider_denied': 'Provider denied lookup',
  'ip.error.network_error': 'Provider network error',
  'ip.error.http_error': 'Provider request failed',
  'ip.error.invalid_response': 'Invalid provider response',
  'ip.error.usage_unavailable': 'Provider usage unavailable',
  'ip.error.internal_error': 'Collector unavailable',
  'ip.error.invalid_or_missing_result': 'Missing or invalid IP result',
  'ip.error.lease_expired': 'Task expired; awaiting retry',
  'menu.数据记录.IP 资料库': 'IP library',
};
